import useRouter from './useRouter';
import queryString from 'query-string';

var useQueryParams = function useQueryParams() {
  var _useRouter = useRouter(),
      location = _useRouter.location;

  return queryString.parse(location.search);
};

export default useQueryParams;